import { getControlItem, toggleFullScreen } from '../utils/helpers'
import { BUTTON_ICON_CLASS, CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class FullScreen extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderFullScreenButton()
  }

  private renderFullScreenButton() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--fullscreen'],
        },
        children: [
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--fullscreen-inverted'] },
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--fullscreen-exit'] },
        ],
        eventListeners: ['click'],
        callback: () => toggleFullScreen(this.wrapperElement),
      }),
    )
  }
}
